import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

export interface ContactInfo {
  phone?: string;
  mobile?: string;
  email?: string;
  fax?: string;
  url?: string;
}

@Injectable({
  providedIn: 'root',
})
export class ContactInfoAdapter {
  fromResource$(
    fhirTelecom: fhir4.ContactPoint[] = [],
  ): Observable<ContactInfo> {
    const phone = fhirTelecom.find(
      ({ system, use }) => system === 'phone' && use !== 'mobile',
    )?.value;
    const mobile = fhirTelecom.find(
      ({ system, use }) => system === 'phone' && use === 'mobile',
    )?.value;
    const email = fhirTelecom.find(({ system, use }) => system === 'email')
      ?.value;
    const fax = fhirTelecom.find(({ system, use }) => system === 'fax')?.value;
    const url = fhirTelecom.find(({ system, use }) => system === 'url')?.value;

    const contactDetails = {
      phone,
      mobile,
      email,
      fax,
      url,
    };

    return of(contactDetails);
  }
}
